import axios from 'axios';
import environment from 'environment';

import { JsonResponse, Pagination } from 'core/models/response';
import { Region } from '../models/region';

interface GetRegionsResponse {
	regions: Region[];
	pagination:Pagination
}

export interface CreateRegionPayload {
	name: {
		en: string;
		ar: string;
	};
	active: 0 | 1;
	country_id: number;
}

export const onGetAllRegions = () => {
	return axios.get<JsonResponse<Region[]>>(`${environment.BASE_API_ENDPOINT}/global/regions`);
};

export const onGetRegions = (page=1) => {
	return axios.get<JsonResponse<GetRegionsResponse>>(`${environment.BASE_API_ENDPOINT}/admin/regions`,{
		params:{
			page
		}
	});
};

export const onGetRegion = (regionId: string) => {
	return axios.get<JsonResponse<Region>>(`${environment.BASE_API_ENDPOINT}/admin/regions/${regionId}`);
};

export const onCreateRegion = (data: CreateRegionPayload) => {
	return axios.post<JsonResponse<Region>>(`${environment.BASE_API_ENDPOINT}/admin/regions`, data);
};

export const onUpdateRegion = (regionId: string, data: Partial<CreateRegionPayload>) => {
	return axios.put<JsonResponse<Region>>(`${environment.BASE_API_ENDPOINT}/admin/regions/${regionId}`, data);
};

export const onDeleteRegion = (regionId: number) => {
	return axios.delete(`${environment.BASE_API_ENDPOINT}/admin/regions/${regionId}`);
};
